import { CLASSROOM_MODULE_IMPORT_SECTIONS } from '../actions';
import { createFolder, createSection } from '../api';
import * as classRoomSelectors from '../../selectors/classroom';
import * as userSelectors from '../../selectors/user';
import { importer } from '../importExport';
import toastOperation from '../../toasts/operations';

const save = ({ classRoom, educatorOnly }) => (section) => () =>
  section.content
    ? createSection(classRoom, { ...section, educatorOnly })
    : createFolder(classRoom, { ...section, educatorOnly });

const seriesReducer = (curr, next) => {
  const p = curr.length ? curr[curr.length - 1] : Promise.resolve();
  curr.push(p.then(next));
  return curr;
};
const series = (a) => Promise.all(a.reduce(seriesReducer, []));

const importMaterialAction = (status, payload) => ({
  type: CLASSROOM_MODULE_IMPORT_SECTIONS,
  status,
  payload,
});

const importMaterialStarted = importMaterialAction.bind(null, 'started');
const importMaterialSuccess = importMaterialAction.bind(null, 'success');
const importMaterialError = importMaterialAction.bind(null, 'error');

const importMaterials = ({ materials, educatorOnly }) => async (
  dispatch,
  getState
) => {
  const state = getState();
  const userId = userSelectors.currentUserId(state);
  const classRoom = classRoomSelectors.currentClassRoomId(state);

  dispatch(importMaterialStarted({ classRoom, materials }));

  try {
    const importMaterial = (m) => () =>
      importer(save({ classRoom, educatorOnly }), userId)(m);
    const savedSections = [].concat(
      ...(await series(materials.map(importMaterial)))
    );

    dispatch(importMaterialSuccess({ classRoom, sections: savedSections }));
    dispatch(
      toastOperation.showToast({
        emoji: '✅',
        message: 'The materials were imported successfully.',
      })
    );
  } catch (error) {
    dispatch(importMaterialError(error));
    dispatch(
      toastOperation.showToast({
        emoji: '🤔',
        message: 'There was an error when importing the materials.',
      })
    );
  }
};

export default importMaterials;
